/**
 * CCPA opt-out button
 */
$(self).ready(() => {
  const $ccpael = $('#ccpa-optout')
  if ($ccpael) {
    if (window.is_adfree || window.is_inside) {
      $ccpael.css('display', 'none')
    }
    $ccpael.click(function() {
      htlbid.ccpaOptOut()
      $ccpael.attr('disabled', true)
      $ccpael.removeClass('--red')
      $ccpael.addClass('--disabled')
      $ccpael.after(
        '<p>We have recorded your "Do Not Sell" preference. Your personal data will not be sold.</p>',
      )
    })
  }
})
